(function() {
    theme.VehicleSearch = (function() {
        const data_url = theme.custom.vehicleFitmentData;
        const search_url = theme.custom.vehicleSearchCollection;
        const savedValue = document.querySelector(".ymm_current-fitment")

        let yearOption = document.querySelector("#dropdown_1")
        let makeOption = document.querySelector("#dropdown_2")
        let modelOption = document.querySelector("#dropdown_3")
        let vehicleUrl = window.location.href

        let secondary = {
          year: document.querySelector(".ymm__select-year"),
        }


        let arrays = {
            years: [],
            makes: [],
            models: [],
            selectyear: `<option selected>Select Year</option>`,
            selectmake: `<option selected>Select Make</option>`,
            selectmodel: `<option selected>Select Model</option>`,
        };

        let selectors = {
            ymmcontainer: document.querySelector(".ymm-container"),
            ymmbuttons: document.querySelector(".ymm-buttons"),
            search: document.querySelector("#ymm_search"),
            reset: document.querySelector("#ymm_reset"),
            change: document.querySelector("#ymm_change"),
            title: document.querySelector(".ymm_title"),  
            disclaimer: document.querySelector(".ymm-disclaimer"),
            query: window.location.search,
            cartBtn: document.querySelector('.ymm_button.btn'),
            vehicleSelected: document.querySelector(".ymm-searchbox"),
            vehicleNotSelected: document.querySelector(".ymm-searchbox_selected"), 
            currentVehicle: document.querySelector("#ymm_current-vehicle")
        };   

         let header = {
            fitmentContainer: document.querySelector(".site-nav__fitment"),
            fitment: document.querySelector("#HeaderFitment"),
            products: document.querySelector("#headerFitmentProducts"),
            reset: document.querySelector("#headerFitmentChange")
        }; 

        //Sets default values for dropdowns
        makeOption.innerHTML = arrays.selectmake;
        modelOption.innerHTML = arrays.selectmodel;

        function enableSelect(el) {
            el.removeAttribute("disabled");
            el.parentElement.classList.remove("small--hide");
        }

        function resetVehicle() {
          selectors.search.disabled = makeOption.disabled = modelOption.disabled = true;
          yearOption.selectedIndex = makeOption.selectedIndex = modelOption.selectedIndex = 0;
          window.localStorage.removeItem("vehicleFitment", fitmentString)
        }

        //Resets values when reset button clicked
        selectors.reset.addEventListener("click", () => {
          resetVehicle()
        });

        function storeFitment() {
            let selectedFitment = {
                year: yearOption.value,
                make: makeOption.value,
                model: modelOption.value,
                collection: `${yearOption.value}+${makeOption.value}+${modelOption.value}`.replace(/[ /]/g, "-"),
                params: `?rq=yr_${yearOption.value}~mk_${makeOption.value}~md_${modelOption.value}`.replace(/\//g, "-"),
            }

            //Converts fitment into string
            let fitmentString = JSON.stringify(selectedFitment)

            //Saves fitment to local storage
            window.localStorage.setItem("vehicleFitment", fitmentString)
        }

        const fitmentdata = fetch(data_url)
            .then((response) => response.json())
            .then((data) => { return data })

        let years = fitmentdata.then(function(data) {
            let fitments = data.fitments;
            fitments.forEach((fitment) => {
                arrays.years.push(`<option class="ymm_option-year" value="${fitment.year}">${fitment.year}</option>`);
            });
            let uniqyears = [...new Set(arrays.years)].sort();
            yearOption.innerHTML = arrays.selectyear + uniqyears;

            let yearData = yearOption.innerHTML 

         //   document.dispatchEvent(new CustomEvent("custom:fitmentChanged", {
         //     detail: { fitments: yearData, option: secondary.year }                
         //   }))
          
        });

        yearOption.addEventListener("change", () => {
            getSecondFitment()
            enableSelect(makeOption)
            modelOption.selectedIndex = 0;
        })

        function getSecondFitment() {
            let makes = fitmentdata.then(function(data) {
                let fitments = data.fitments;
                arrays.makes = [];
                fitments.forEach((fitment) => {
                    if (fitment.year == yearOption.options[yearOption.selectedIndex].value) {
                        arrays.makes.push(`<option class="ymm_option-make" value="${fitment.make}">${fitment.make}</option>`)
                    }
                });
                let uniqmakes = [...new Set(arrays.makes)].sort();
                makeOption.innerHTML = arrays.selectmake + uniqmakes;

                let makeData = makeOption.innerHTML;

                document.dispatchEvent(new CustomEvent("custom:fitmentChanged", {
                  detail: { fitments: makeData, option: secondary.year }                
                }))  
            });
        }

        makeOption.addEventListener("change", () => {
            getThirdFitment()
            enableSelect(modelOption)          
        })

        function getThirdFitment() {
            let models = fitmentdata.then(function(data) {
                let fitments = data.fitments;               
                arrays.models = [];
                fitments.forEach((fitment) => {
                    if (fitment.year == yearOption.options[yearOption.selectedIndex].value && fitment.make == makeOption.options[makeOption.selectedIndex].value) {
                        arrays.models.push(`<option class="ymm_option-model" value="${fitment.model}">${fitment.model}</option>`)                       
                    }
                    
                });
                modelOption.innerHTML = arrays.selectmodel + arrays.models.sort();
                enableSelect(selectors.search)
            });
        }

        modelOption.addEventListener("change", () => {
           selectors.ymmbuttons.classList.remove("small--hide");          
        })

        

         //Hides Models with no data
         makeOption.addEventListener("change", () => { 
            let options = document.querySelectorAll(".ymm_option-model")
            options.forEach((option) => {
              if (!option.value) {
                option.classList.add("hide")                
              }          
            }); 
        })

        document.addEventListener("custom:fitmentChanged", e => {
          let option = e.detail.option;
          let fitments = e.detail.fitments; 
          
          setFitmentOptions(option, fitments)
        }) 

        function setFitmentOptions(fitments, option) {

        // option.innerHTML = fitments 
        }

        //Creates Search Url
        selectors.search.addEventListener("click", () => {
            storeFitment();
            vehicle_tags = `${yearOption.value}+${makeOption.value}+${modelOption.value}`.replace(/\//g, "-");
            vehicle_params = `?rq=yr_${yearOption.value}~mk_${makeOption.value}~md_${modelOption.value}`.replace(/\//g, "-");
            results_url = `${search_url}${vehicle_tags}${vehicle_params}`.replace(/ /g, "-");      
            window.location = results_url;
        })

        //Vehicle Search Results
        let savedFitment = JSON.parse(localStorage.getItem("vehicleFitment"));
        let collection_url = `${search_url}${savedFitment.collection}${savedFitment.params}`;

        if (savedValue) {
            savedValue.innerHTML = `Your vehicle: ${savedFitment.year} ${savedFitment.make} ${savedFitment.model} <a href="" class="ymm_change-fitment hide">Change</a>`                  
        }

        function setHeaderFitment() {
          //Hide YMM Searchbox
          if ( window.location.href != 'https://www.retromanufacturing.com/') {
           selectors.ymmcontainer.classList.add("medium-up--hide")         
          }  
          
          //Display Header Fitment and Link
          header.fitmentContainer.classList.remove("hide")
          header.fitment.innerHTML = `${savedFitment.year} ${savedFitment.make} ${savedFitment.model}`;
          header.fitment.href = header.products.href = collection_url;              
        }

        //Reset fitment on header 'Change Fitment' click
        header.reset.addEventListener("click", () => {
          selectors.ymmcontainer.classList.remove("medium-up--hide")
          header.fitmentContainer.classList.add("hide")
          console.log("reset fitment")
          resetVehicle()       
        })  

        function appendSearchUrl() {
            let itemLinks = document.querySelectorAll(".filter_link a, .grid-item__link, button.tag_filter-remove a");

            itemLinks.forEach((item) => {
                let link = item.getAttribute("href") + selectors.query
                item.setAttribute("href", link)
            })           
        }

        function linkToParentCollection() {
            let items = document.querySelectorAll("a.vehicle-filter, a.tag_universal, .return-link, #ymm_current-vehicle");

            items.forEach((item) => {
                item.setAttribute("href", collection_url)
            })
        }

        function displayFitmentTitle({ year, make, model, collection, params }) {
            if (selectors.title) {
                selectors.title.innerHTML = `${year} ${make} ${model}`
            }
            if (selectors.cartBtn) {
                selectors.cartBtn.innerHTML = `Continue shopping for your ${year} ${make} ${model}`
                selectors.cartBtn.href = collection_url
            }
        }

        //Vehicle Search Results Page
        if (window.location.href.indexOf(search_url) > -1 || savedFitment) {      
            appendSearchUrl()
            linkToParentCollection()           
        }

        function setYear(){ yearOption.value = savedFitment.year}
        function setMake(){ makeOption.value = savedFitment.make}
        function setModel(){ modelOption.value = savedFitment.model}
     
        async function applyVehicleFitment() {                    
          try {                   
            await setYear()
            await getSecondFitment()
            await enableSelect(makeOption)          
            await setMake()
            await getThirdFitment()
            await enableSelect(modelOption)
            await setModel() 
            await selectors.ymmbuttons.classList.remove("small--hide"); 
          } catch (err) {                  
            console.log(err);              
          }        
        } 

      function showCurrentVehicle() {      
        selectors.currentVehicle.innerHTML = `${savedFitment.year} ${savedFitment.make} ${savedFitment.model}` 
        selectors.disclaimer.classList.add("small--hide")
        selectors.vehicleSelected.classList.add("small--hide")
        selectors.vehicleNotSelected.classList.remove("hide")
      }

      function changeVehicle() {
        selectors.disclaimer.classList.remove("small--hide")   
        selectors.vehicleSelected.classList.remove("small--hide")
        selectors.vehicleNotSelected.classList.add("hide")
      }

      selectors.change.addEventListener("click", () => {
           changeVehicle()
           resetVehicle()
      })

          
     window.addEventListener('load', (event) => {
      if (savedFitment) {
        showCurrentVehicle()
        displayFitmentTitle(savedFitment)
        setHeaderFitment()
      }
     
      if (savedFitment && window.location.href.indexOf(search_url) > -1) {
          applyVehicleFitment()           
      }
      })
    })();
})();